import { playlists as catalog } from '../data/tracks';
import { BUSINESS_PLAYLISTS } from '../data/businessPlaylists';

/**
 * Returns up to `max` default catalog playlists suggested for the user's businessType
 * that are NOT already in their liked or created playlists.
 *
 * @param {object} opts
 * @param {string|null} opts.businessType - e.g. 'cafe', 'restaurant'
 * @param {Set<string>} opts.likedPlaylistIds - Set of liked playlist IDs
 * @param {Array<{id: string}>} opts.userPlaylists - user-created playlists
 * @param {number} opts.max - max results (default 3)
 * @returns {Array} playlist objects
 */
export function getSuggestedPlaylists({ businessType, likedPlaylistIds, userPlaylists, max = 3 }) {
  if (!businessType) return [];
  const yoursIds = new Set([
    ...likedPlaylistIds,
    ...userPlaylists.map(p => p.id),
  ]);
  const candidateIds = BUSINESS_PLAYLISTS[businessType] || [];
  const suggested = candidateIds
    .filter(id => !yoursIds.has(id))
    .map(id => catalog.find(p => p.id === id))
    .filter(Boolean)
    .slice(0, max);
  return suggested;
}

/**
 * Returns a human-readable label for a businessType.
 */
export function businessTypeLabel(businessType) {
  const LABELS = {
    cafe: 'café',
    restaurant: 'restaurant',
    bar: 'bar',
    salon: 'coiffeur',
    boutique: 'boutique',
    spa: 'spa',
    gym: 'salle de sport',
    hotel: 'hôtel',
    office: 'bureau',
  };
  return LABELS[businessType] || businessType;
}
